import PDFRenderer from "./pdfRenderer";
import "./index.scss";

export default function PrintPDF() {
  return <PDFRenderer />;
}
